import { hasProperty, isObject } from '@direct-frontend/stdlib';
import { createErrorMarker } from './createErrorMarker';

export const createErrorInstanceOf =
    <T extends string>(errorName: T) =>
    (instance: unknown) => {
        return isObject(instance) && hasProperty(instance, createErrorMarker(errorName));
    };
